import axios from 'axios'

const loco = window.location
const appRootUrl = `${loco.protocol}//${loco.host}${process.env.BASE_URL}`
const url = appRootUrl + 'api/FeatureToggle/GetFeatureToggle'

var featureToggle
var msgFeatureToggle

const readFeatureToggle = new Promise(function (resolve, reject) {
  axios.post(url, {
    Sistema: 'INTEGRA'
  })
    .then(r => {
      featureToggle = r.data
      msgFeatureToggle = 'Funcionalidade desabilitada no momento tente mais tarde.'
      resolve(true);
    }).catch(r => {
      console.log(r);
      reject(new Error('Failed to read featureToggle.' + r.message))
    })
})

export {
  readFeatureToggle,
  featureToggle,
  msgFeatureToggle
}